module.exports = __webpack_public_path__ + "img/databasing-icon.68b54605.png";